import { CalendarGridChip } from '../../../CalendarGridChip'
import { CalendarGridItemTrigger } from '../../../CalendarGridItemTrigger'

import { getCalendarGridWeekSpanStyle } from './CalendarGridWeekAllDaySpan.utils'

import * as styles from './CalendarGridWeekAllDaySpan.module.css'

function CalendarGridWeekAllDaySpan({
  endIndex,
  item,
  startIndex,
  track,
  onClickItem,
}) {
  return (
    <div
      className={styles.CalendarGridWeekAllDaySpan}
      style={getCalendarGridWeekSpanStyle({ endIndex, startIndex, track })}
    >
      <CalendarGridItemTrigger
        Trigger={CalendarGridChip}
        item={item}
        triggerProps={{ item }}
        onClickItem={onClickItem}
      />
    </div>
  )
}

export default CalendarGridWeekAllDaySpan
